/** A single `@`-mention suggestion (shape produced by useMultiSubmitData). */
export interface MentionOption {
  id: string;
  display: string;
  label: string;
  name: string;
}

/**
 * Build the deduped suggestion list for one row's email cell: drop any mention
 * whose email (`label`) already appears in the row's To/CC/BCC. Matching is
 * trimmed and case-insensitive. Mirrors the single-submit popup behaviour.
 */
export function filterMentionOptions(mentions: MentionOption[], usedRaw: string[]): MentionOption[] {
  const used = new Set(
    usedRaw
      .flatMap((raw) => (raw || '').split(','))
      .map((part) => part.trim().toLowerCase())
      .filter((part) => part !== ''),
  );
  return mentions.filter((mention) => !used.has(mention.label.toLowerCase()));
}

/**
 * Match the text typed after `@` against each suggestion's name and email, trimmed and
 * case-insensitive. react-mentions only matches an array `data` prop against `display`
 * (the email), so this is passed to `<Mention data>` as a function instead.
 * @param mentions - suggestions to search.
 * @param query - text typed after the trigger.
 * @returns the suggestions whose name or email contains the query.
 */
export function searchMentionOptions(mentions: MentionOption[], query: string): MentionOption[] {
  const needle = query.trim().toLowerCase();
  return mentions.filter((mention) => `${mention.name} ${mention.label}`.toLowerCase().includes(needle));
}
